import { ModalsKeys } from 'types/helpers';

import { IActionWithPayload } from '../types';

export enum ActionTypes {
    SET_MODAL = 'ui/SET_MODAL',
    TOGGLE_MODAL = 'ui/TOGGLE_MODAL',
    CHANGE_MODAL = 'ui/CHANGE_MODAL'
}
export interface ModalData {
    type: ModalsKeys | null;
    url?: string;
    data?: any | null;
    callback?: () => void;
}
export interface UIState {
    indicators: {
        loading: boolean;
        error: any | null;
        showModal: boolean;
    };
    redirectUrl: string | null;
    modalType: ModalsKeys | null;
    modalData: ModalData | null;
}

export type Actions =
    | IActionWithPayload<ActionTypes.SET_MODAL, boolean>
    | IActionWithPayload<ActionTypes.TOGGLE_MODAL, ModalData>
    | IActionWithPayload<ActionTypes.CHANGE_MODAL, { type: ModalsKeys; data: any }>;
